import type { EnquiryPayload, EnquiryRequestDto, EnquirySuccessResponse } from './Enquiry.types';

export const mapEnquiryPayloadToRequestDto = (payload: EnquiryPayload): EnquiryRequestDto => {
  return {
    name: payload.name.trim(),
    email: payload.email.trim().toLowerCase(),
    phoneNumber: payload.phoneNumber.trim(),
    service: payload.service.trim(),
    message: payload.message.trim(),
  };
};

export const mapEnquirySuccessResponse = (
  response: EnquirySuccessResponse,
): EnquirySuccessResponse => {
  return {
    status: response.status,
    code: response.code,
    message: response.message,
    data: response.data,
  };
};
